export * from './data-search.model';


// WEBPACK FOOTER //
// ./node_modules/@rx/table/models/index.ts